/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ObjectObjectConfiguration as __Configuration } from '../object-object-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class ApiService extends __BaseService {
  static readonly summaryContactPath = '/contact';
  static readonly consumesContactPath = '/contact';
  static readonly responsesContactPath = '/contact';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Contact Post.
   * @param body Post contact
   */
  summaryContactResponse(body?: {}): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'SUMMARY',
      this.rootUrl + `/contact`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Contact Post.
   * @param body Post contact
   */
  summaryContact(body?: {}): __Observable<null> {
    return this.summaryContactResponse(body).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Contact Post.
   * @param body Post contact
   */
  consumesContactResponse(body?: {}): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'CONSUMES',
      this.rootUrl + `/contact`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Contact Post.
   * @param body Post contact
   */
  consumesContact(body?: {}): __Observable<null> {
    return this.consumesContactResponse(body).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Contact Post.
   * @param body Post contact
   */
  responsesContactResponse(body?: {}): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'RESPONSES',
      this.rootUrl + `/contact`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Contact Post.
   * @param body Post contact
   */
  responsesContact(body?: {}): __Observable<null> {
    return this.responsesContactResponse(body).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module ApiService {
}

export { ApiService }
